(() => {
  const close = event => {
    document.querySelectorAll('.h5928-mobile-menu[open]').forEach(menu => {
      if (event.type === 'keydown' && event.key === 'Escape') { menu.open=false; menu.querySelector('summary').focus(); }
      else if (event.type === 'click' && (!menu.contains(event.target) || event.target.closest('a'))) menu.open=false;
    });
  };
  document.addEventListener('keydown', close);
  document.addEventListener('click', close);
})();
